/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/order
import { createSelector } from "@reduxjs/toolkit";
import { jobPositionApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from "@bvi/api-interfaces/response/manage-base-data";

export const selectJobPosition = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectJobPositionListResult = () =>
  jobPositionApi.endpoints.getJobPositionList.select();

export const selectResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};

